import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';
import { parseDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';

import { IKnmErknmEventSubmittedDocumentsForm } from '../interfaces/IKnmErknmEventSubmittedDocumentsForm';
import { IDictionaryEventTypeSelectOption } from '../../../CorePackage/DictionariesModule/interfaces/IDictionaryEventTypeSelectOption';

export const getSubmittedDocumentsValidate = (
  arr: IKnmErknmEventSubmittedDocumentsForm[] | undefined,
  type: IDictionaryEventTypeSelectOption | undefined,
  isSigned?: boolean | null | undefined,
  stopDate?: string,
): FormErrors<IKnmErknmEventSubmittedDocumentsForm>[] | string | undefined => {
  if (!arr && type?.label === 'Истребование документов') {
    return 'Поле не может быть пустым';
  }

  if (!arr) {
    return undefined;
  }

  return arr?.map(item => {
    const submissionDeadlineRequired = makeRequired('Поле не может быть пустым')(item.submissionDeadline);
    let submissionDeadlineLaterThanStopDate: string | undefined;

    if (item.submissionDeadline && stopDate) {
      const parseSubmissionDeadline = parseDate({
        date: item.submissionDeadline || '',
        parseFormat: DATE_FORMAT_LONG_FNS,
      });
      const parseStopDate = parseDate({ date: stopDate || '', parseFormat: DATE_FORMAT_LONG_FNS });

      if (parseSubmissionDeadline && parseStopDate && parseSubmissionDeadline > parseStopDate) {
        submissionDeadlineLaterThanStopDate =
          'Срок представления документов не должен быть позже даты окончания действия';
      }
    }

    return {
      documentTitle: makeRequired('Поле не может быть пустым')(item.documentTitle),
      requestDateTime: makeRequired('Поле не может быть пустым')(item.requestDateTime),
      submissionDeadline: submissionDeadlineRequired || submissionDeadlineLaterThanStopDate,
      files: item.status?.id === 1 && isSigned ? makeRequired('Поле не может быть пустым')(item.files) : undefined,
      submissionDateTime:
        item.status?.id === 1 && item.files && item.files?.length > 0 && isSigned
          ? makeRequired('Поле не может быть пустым')(item.submissionDateTime)
          : undefined,
    };
  });
};
